<div class="container" *ngIf="!isLoading(); else loadingTpl">
  <ng-container *ngIf="listing() as data; else errorTpl">

    <!-- Inactive state for public users -->
    <app-inactive-listing *ngIf="!canSeeDetails"></app-inactive-listing>

    <!-- Full details for active or owner -->
    <div class="listing-detail" *ngIf="canSeeDetails">

      <!-- Top Action Bar -->
      <div class="top-bar">
        <div class="breadcrumbs">
          <a routerLink="/">Ana səhifə</a>
          <span class="separator">/</span>
          <span>Elan № {{ data.id }}</span>
        </div>
        <div class="top-actions">
          <button class="btn-complaint" (click)="showComplaintModal.set(true)">
            <i class="fas fa-flag"></i> Şikayət et
          </button>
        </div>
      </div>

      <!-- Status Banner for Owner -->
      <app-status-banner
        *ngIf="isOwner() && data.status !== 'Active'"
        [status]="data.status!"
        [rejectionReason]="data.rejectionReason"
        [expiresAt]="data.expiresAt"
      ></app-status-banner>

      <!-- Main Section -->
      <div class="main-grid">
        <div class="left-column">
          <app-listing-gallery [images]="galleryImages"></app-listing-gallery>

          <!-- Mobile Info (visible only on small screens) -->
          <div class="mobile-only mt-4">
            <app-listing-main-info [listing]="data"></app-listing-main-info>
          </div>

          <app-listing-description [description]="data.description || ''"></app-listing-description>

          <app-listing-map [lat]="data.lat" [lng]="data.lng"></app-listing-map>

          <app-share-buttons [listing]="data" class="desktop-only"></app-share-buttons>
        </div>

        <div class="right-column">
          <div class="sticky-sidebar">
            <app-listing-main-info [listing]="data" class="desktop-only"></app-listing-main-info>

            <app-contact-card
              [contactName]="data.contactName || ''"
              [contactPhone]="data.contactPhone || ''"
              [ownerType]="data.ownerType!"
              [isOwner]="isOwner()"
              (onVipClick)="showVipModal.set(true)"
            ></app-contact-card>

            <app-share-buttons [listing]="data" class="mobile-only mt-4"></app-share-buttons>
          </div>
        </div>
      </div>

      <!-- Similar Listings -->
      <app-similar-listings [listings]="similarListings()"></app-similar-listings>

    </div>
  </ng-container>
</div>

<!-- Modals -->
<app-vip-upgrade-modal
  *ngIf="showVipModal()"
  [listingId]="listing()?.id?.toString() || ''"
  [packages]="vipPackages"
  (onClose)="showVipModal.set(false)"
  (onSuccess)="onVipSuccess()"
></app-vip-upgrade-modal>

<app-complaint-modal
  *ngIf="showComplaintModal()"
  [listingId]="listing()?.id?.toString() || ''"
  (onClose)="showComplaintModal.set(false)"
></app-complaint-modal>

<!-- Loading State -->
<ng-template #loadingTpl>
  <div class="skeleton-container">
    <div class="skeleton-gallery"></div>
    <div class="skeleton-info"></div>
  </div>
</ng-template>

<!-- Error State -->
<ng-template #errorTpl>
  <div class="error-container">
    <h1>{{ error() || 'Elan tapılmadı' }}</h1>
    <a routerLink="/" class="btn-primary">Geri dön</a>
  </div>
</ng-template>
